/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BcServiceDetailResponse } from '../../models/bc-service-detail-response';
import { BusinessCentralServiceType } from '../../models/business-central-service-type';

export interface GetBusinessCentralServicesSearch$Params {
  serviceType: BusinessCentralServiceType;
  searchText: string;
  offerId?: number;
}

export function getBusinessCentralServicesSearch(http: HttpClient, rootUrl: string, params: GetBusinessCentralServicesSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BcServiceDetailResponse>>> {
  const rb = new RequestBuilder(rootUrl, getBusinessCentralServicesSearch.PATH, 'get');
  if (params) {
    rb.query('serviceType', params.serviceType, {});
    rb.query('searchText', params.searchText, {});
    rb.query('offerId', params.offerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BcServiceDetailResponse>>;
    })
  );
}

getBusinessCentralServicesSearch.PATH = '/business-central-services-search';
